// extracted by mini-css-extract-plugin
export default {"link":"_1Ezv6"};